/**
 * Textos del aviso de IA (GEN-PX-005, spec §3.4, capa 6B §6B.8).
 *
 * Redacción heredada del aviso anterior (HU-037 / #497, fijada por Legal): no
 * editar sin VoBo de Erin. Nunca devuelve vacío: si el nombre no resuelve, cae
 * a la variante sin nombre (el estado seguro es informar).
 */

const SEC = 'Sus respuestas pueden contener errores y no sustituyen el criterio de un profesional.'

const nombreValido = (n) => (typeof n === 'string' && n.trim() ? n.trim() : '')

/** Línea compacta bajo el campo. Con cargo conocido, lo lleva con la palabra «agente». */
export function textoLinea(nombre, cargo) {
  const n = nombreValido(nombre)
  const c = nombreValido(cargo)
  return n
    ? `Hablas con ${n}${c ? ` (agente · ${c})` : ''}, un sistema de IA, no con una persona. ${SEC}`
    : `Hablas con sistemas de IA, no con personas. ${SEC}`
}

/** Texto legal completo (ⓘ): incluye el desmentido del cargo, que no se recorta. */
export function textoLegal(nombre, cargo) {
  const n = nombreValido(nombre)
  if (!n) {
    return `Los miembros del equipo que ves aquí son sistemas de IA, no personas. Los cargos que acompañan a sus nombres describen su especialización, no a profesionales humanos. ${SEC}`
  }
  const c = nombreValido(cargo)
  const clausula = c
    ? `El cargo que aparece junto a su nombre («${c}») describe la especialización de este agente, no a un profesional humano.`
    : 'El cargo que aparece junto a su nombre describe la especialización de este agente, no a un profesional humano.'
  return `Estás hablando con ${n}, un sistema de IA — no con una persona. ${clausula} ${SEC}`
}

/** A la derecha de la línea: el agente y su cargo, con la palabra «agente». */
export const textoAgente = (nombre, cargo) => {
  const n = nombreValido(nombre)
  if (!n) return ''
  const c = nombreValido(cargo)
  return c ? `Agente ${n} · ${c}` : `Agente ${n}`
}
